/**
 * Object for order delivery status.
 * @constant {Object}
 */
const DeliveryStatus = {
  PENDING: 'pending',
  SHIPPED: 'shipped',
  PARTIALLY_DELIVERED: 'partially delivered',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};

/**
 * Object for order status.
 * @constant {Object}
 */
const OrderStatus = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

/**
 * Dropdown options for OrderStatus.
 * @constant {Array<{label: string, value: string}>}
 */
const ORDER_STATUS_FOR_RM_PERSON_OPTIONS = [
  { label: 'Draft', value: OrderStatus.DRAFT },
  { label: 'Submitted', value: OrderStatus.SUBMITTED },
];

/**
 * Dropdown options for OrderStatus.
 * @constant {Array<{label: string, value: string}>}
 */
const ORDER_STATUS_FOR_RM_LEAD_OPTIONS = [

  { label: 'Approved', value: OrderStatus.APPROVED },
  { label: 'Rejected', value: OrderStatus.REJECTED },
  { label: 'Draft', value: OrderStatus.DRAFT },
];

/**
 * Dropdown options for DeliveryStatus.
 * @constant {Array<{label: string, value: string}>}
 */
const DELIVERY_STATUS_OPTIONS = [
  { label: 'Pending', value: DeliveryStatus.PENDING },
  { label: 'Shipped', value: DeliveryStatus.SHIPPED },
  { label: 'Partially Delivered', value: DeliveryStatus.PARTIALLY_DELIVERED },
  { label: 'Delivered', value: DeliveryStatus.DELIVERED },
  { label: 'Cancelled', value: DeliveryStatus.CANCELLED },
];

export { DeliveryStatus, OrderStatus, ORDER_STATUS_FOR_RM_PERSON_OPTIONS, ORDER_STATUS_FOR_RM_LEAD_OPTIONS, DELIVERY_STATUS_OPTIONS };